import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDatePicker } from "../../../../../../common/components/masked_inputs/default_date_picker_input";
import { DefaultNomeAuditor } from "../../../../../../common/components/default_nome_auditor";
import { DefaultDataAuditoria } from "../../../../../../common/components/default_data_auditoria";

type Props = {
  tipoPesquisa: number;
  pesquisa: string | Date | number | null;
  status: number;
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void;
  handlePesquisa: (v: string | Date | number | null) => void;
  handleStatus: (s: number) => void;
};

export const Header = ({
  tipoPesquisa,
  pesquisa,
  status,
  handlePesquisa,
  handleStatus,
  handleTipoPesquisa,
  onClearFilters,
}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
          <div className="flex gap-1">
            <FormControl size="small" sx={{ width: "275px" }}>
              <InputLabel id="modulo-dashboard" size="small">
                Pesquisar por
              </InputLabel>
              <Select
                size="small"
                labelId="modulo-dashboard"
                label="Pesquisar por"
                value={tipoPesquisa}
                onChange={(event: SelectChangeEvent<number>) => {
                  handlePesquisa("");
                  handleTipoPesquisa(event.target.value as number);
                }}
              >
                <MenuItem value={0}>Data da Auditoria</MenuItem>
                <MenuItem value={1}>Auditor</MenuItem>
                <MenuItem value={2}>Ano</MenuItem>
                <MenuItem value={3}>Evento</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-full">
            {tipoPesquisa === 0 ? (
              <DefaultDatePicker
                label="Pesquisar"
                name="search_by_name"
                value={typeof pesquisa === "string" ? pesquisa : ""}
                onChangeValue={(e) => handlePesquisa(e)}
              />
            ) : tipoPesquisa === 3 ? (
              <DefaultInput
                label="Pesquisar"
                name="search_by_name"
                value={typeof pesquisa === "string" ? pesquisa : ""}
                onChangeValue={handlePesquisa}
              />
            ) : tipoPesquisa === 1 ? (
              <DefaultNomeAuditor
                name="Pesquisar"
                value={typeof pesquisa === "number" ? pesquisa : null}
                onChange={(valor) => handlePesquisa(valor ?? null)}
              />
            ) : tipoPesquisa === 2 ? (
              <DefaultDataAuditoria
                name="Pesquisar"
                value={typeof pesquisa === "number" ? pesquisa : null}
                onChange={(valor) => handlePesquisa(valor ?? null)}
              />
            ) : (
              <></>
            )}
          </div>
          <FormControl size="small" sx={{ width: "220px" }}>
            <InputLabel id="status-label" size="small">
              Status
            </InputLabel>
            <Select
              size="small"
              labelId="status-label"
              label="Status"
              value={status}
              onChange={(event: SelectChangeEvent<number>) => {
                handleStatus(event.target.value as number);
              }}
            >
              <MenuItem value={0}>Todas auditorias</MenuItem>
              <MenuItem value={1}>Em aberto</MenuItem>
              <MenuItem value={2}>Encerradas</MenuItem>
            </Select>
          </FormControl>
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={
                  <DynamicIcon
                    nameIcon="ClearRounded"
                    size={25}
                    className="text-black"
                  />
                }
                buttonColor="yellow"
                onClick={handleClearFilters}
              >
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
